(() => {

    const body = document.querySelector('body');
    let pageHeaderEl = document.querySelector('.wonderful-header');
    
    if (!pageHeaderEl) return;

    let mobileMenuOpen = false;
    let scrollPosition = 0;

    const lockScroll = (mobile) => {
        scrollPosition = window.pageYOffset - 45;
        body.style.overflow = 'hidden';
        body.style.position = 'fixed';
        body.style.top = `-${scrollPosition}px`;
        body.style.width = '100%';

        let datepickerContainer = document.getElementById('datepickers-container');
        if (datepickerContainer) {
            datepickerContainer.style.top = `${scrollPosition}px`;
        }

        if (mobile) {
            mobileMenuOpen = true;
        }
    }

    const unlockScroll = (mobile) => {
        body.style.removeProperty('overflow');
        body.style.removeProperty('position');
        body.style.removeProperty('top');
        body.style.removeProperty('width');
        window.scrollTo(0, scrollPosition);

        let datepickerContainer = document.getElementById('datepickers-container');
        if (datepickerContainer) {
            datepickerContainer.style.removeProperty('top');
        }

        if (mobile) {
            mobileMenuOpen = false;
        }
    }

    const handleNavbarAfterScrolling = (scrollPosition) => {
        if (scrollPosition > 10) {
            pageHeaderEl.classList.toggle('--filled', true);
        } else {
            pageHeaderEl.classList.remove('--filled');
        }

        if (scrollPosition <= 54) {
            pageHeaderEl.classList.add('--fill-button');
        } else {
            pageHeaderEl.classList.remove('--fill-button');
        }
    }

    document.addEventListener('scroll', function () {
        handleNavbarAfterScrolling(window.pageYOffset);
    });

    let mobileMenu = document.getElementById('header-mobile-checkbox');
    mobileMenu.addEventListener('change', () => {
        let classList = pageHeaderEl.classList;
        let classManip = '--mobile-open';

        if (classList.contains(classManip)) {
            classList.remove(classManip);
            unlockScroll(true);
        } else {
            classList.add(classManip);
            lockScroll(true);
        }
    });

    pageHeaderEl.querySelectorAll('.header-items > ul > li').forEach((headerItem) => {
        headerItem.querySelector('a').addEventListener('click', (e) => {
            if (mobileMenuOpen) {
                let targetClasses = e.target.classList;
                if (targetClasses.contains('--has-children')) {
                    e.preventDefault();
                }
            }
        });

        headerItem.addEventListener('click', (e) => {
            let subMenu = headerItem.querySelector('.wonderful-header--sub-menu');

            if (subMenu) {
                subMenu.classList.toggle('--open');
            }
        });
    });

    pageHeaderEl.querySelectorAll('.header-items > ul > li .wonderful-header--sub-menu').forEach((item) => {
        item.addEventListener('click', (event) => {
            event.stopPropagation();
        });
    });

    const navItemContainer = pageHeaderEl.querySelector('.wonderful-header--events-items');
    pageHeaderEl.querySelectorAll('.wonderful-header--events-category').forEach((link) => {
        link.addEventListener('click', (e) => {
            pageHeaderEl.querySelector('.wonderful-header--events-category.--open').classList.remove('--open');

            navItemContainer.querySelector('.--open').classList.remove('--open');
            navItemContainer.querySelector('#event-item-' + link.getAttribute('data-opens')).classList.add('--open');

            link.classList.add('--open');
        });
    });

    pageHeaderEl.querySelectorAll('h4[data-opens]').forEach((item) => {
        let targetToToggle = pageHeaderEl.querySelector('[data-mobile-id="' + item.getAttribute('data-opens') + '"]');

        if (targetToToggle) {
            item.addEventListener('click', () => {
                item.classList.toggle('opened');
                const opened = targetToToggle.classList.toggle('--open');

                if (opened) {
                    let height = 100; // Base offset
                    Object.values(targetToToggle.children).forEach((child) => {
                        height += child.getBoundingClientRect().height;
                    });

                    targetToToggle.style.maxHeight = height + 'px';
                } else {
                    targetToToggle.style.maxHeight = null;
                }
            });
        }
    });

    const floatingBookingEngine = new (() => {
        let floatingBookingEngineEl = document.querySelector('.floating-booking-widget');
        const bookNowButton = floatingBookingEngineEl.querySelector('.booking-widget--book a');
        let isOpen = false;
        let bookingEngineTimeout = null;

        let clearAnimationTimeout = () => {
            clearTimeout(bookingEngineTimeout);
        };

        let show = () => {
            clearAnimationTimeout();

            isOpen = true;

            floatingBookingEngineEl.style.display = 'flex';
            bookingEngineTimeout = setTimeout(() => {
                floatingBookingEngineEl.classList.add('--open');
            }, 25);
            lockScroll();
        }

        let hide = () => {
            clearAnimationTimeout();

            isOpen = false;

            setTimeout(() => {
                floatingBookingEngineEl.classList.add('--closing');

                bookingEngineTimeout = setTimeout(() => {
                    floatingBookingEngineEl.classList.remove('--open', '--closing');
                    floatingBookingEngineEl.style.display = 'none';
                }, 1400);

                if (!mobileMenuOpen) {
                    unlockScroll();
                }
            }, 200);
        }

        bookNowButton.addEventListener('click', () => {
            if (bookNowButton.getAttribute('disabled') != 'disabled') {
                hide();
            }
        });

        floatingBookingEngineEl.addEventListener('click', (event) => {
            if (event.target.classList.contains('floating-booking-widget')) {
                hide();
            }
        });

        return {
            element: floatingBookingEngineEl,
            isOpen,
            show,
            hide
        };
    })();

    document.getElementById('global-book-now').addEventListener('click', (event) => {
        event.preventDefault();

        if (floatingBookingEngine.isOpen) {
            floatingBookingEngine.hide();
        } else {
            floatingBookingEngine.show();
        }

        return false;
    });

    document.querySelector('.floating-booking-widget--close').addEventListener('click', (event) => {
        event.preventDefault();

        floatingBookingEngine.hide();

        return false;
    });

    handleNavbarAfterScrolling(window.pageYOffset);
})()